export enum FeaturesRoutingEnum {
  Authentication = 'authentication',
  SignIn = 'sign-in',
  Events = 'events',
  Candidates = 'candidates',
  Administration = 'administration',
  Companies = 'companies',
  Recruiters = 'recruteurs',
}
